export default __webpack_public_path__ + "static/iss-logo-294b8b106d94d6a852271e425e4f5cc7.svg";